/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs */

const en_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark selected event(s) as Forced Narrative Subtitles`)
};

const fr_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer les evenements selectionnes comme sous-titres narratifs forces`)
};

const de_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse als erzwungene narrative Untertitel markieren`)
};

const it_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrassegna gli eventi selezionati come sottotitoli narrativi forzati`)
};

const ru_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметьте выбранное событие(я) как «Принудительные субтитлы повествования».`)
};

const es_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar los eventos seleccionados como subtítulos narrativos forzados`)
};

const zh_cn2_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定的事件标记为强制叙事字幕`)
};

const ja_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを強制ナレーション字幕としてマークする`)
};

const hi_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटना(ओं) को अनिवार्य कथात्मक उपशीर्षकों के रूप में चिह्नित करें`)
};

const pt_pt2_shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque o(s) evento(s) selecionado(s) como Legendas Narrativas Forçadas.`)
};

/**
* | output |
* | --- |
* | "Mark selected event(s) as Forced Narrative Subtitles" |
*
* @param {Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "de") return de_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "it") return it_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "es") return es_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
	return en_shortcut_keys_desc_toggle_forced_narrative_subtitles(inputs)
});